require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sciences-et-technologies-du-vivant-2-1-3-11.json") })
        }
      }, "path---sciences-et-technologies-du-vivant-2-1-3-11");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sciences-et-technologies-du-vivant-2-1-3-11!./.cache/json/sciences-et-technologies-du-vivant-2-1-3-11.json
// module id = 561
// module chunks = 231608221292675